import { createPerformanceSpans } from '../util/createPerformanceSpans.js';
import { shouldFilterRequest } from '../util/shouldFilterRequest.js';
/** only exported for tests */

function handleFetch(handlerData) {
  if (!handlerData.endTimestamp) {
    return null;
  }

  var startTimestamp = handlerData.startTimestamp,
      endTimestamp = handlerData.endTimestamp,
      fetchData = handlerData.fetchData,
      response = handlerData.response;
  return {
    type: 'resource.fetch',
    start: startTimestamp / 1000,
    end: endTimestamp / 1000,
    name: fetchData.url,
    data: {
      method: fetchData.method,
      statusCode: response.status
    }
  };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */


function handleFetchSpanListener(replay) {
  return function (handlerData) {
    if (!replay.isEnabled()) {
      return;
    }

    var result = handleFetch(handlerData);

    if (result === null) {
      return;
    }

    if (shouldFilterRequest(replay, result.name)) {
      return;
    }

    replay.addUpdate(function () {
      createPerformanceSpans(replay, [result]); // Returning true will cause `addUpdate` to not flush
      // We do not want network requests to cause a flush. This will prevent
      // recurring/polling requests from keeping the replay session alive.

      return true;
    });
  };
}

export { handleFetch, handleFetchSpanListener };